export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8127.586793f3.jpg";